import styled from 'styled-components'

export const BaseIconTitleWrapper = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin: 0 0 24px;

  @media (min-width: 768px) {
    margin: 8px 0 32px;
  }
`
